import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPlans } from 'State/Plans/PlansActions';
import { useSubscription } from 'Hooks/useSubscription';

/*
  Handles:
  1) getting plans with strings/image from DPP. The plans will include:
    a) selectable plans
    b) existing plan (if current subscribeer)
    c) next plan (if exists. "nextSubscription", which is a plan that was purchased but
       isn't active until after the active subscription expires)
  2) preselecting plan - preSelectedPlan can be the planId or the start of the displayName
*/

export const usePlans = (preSelectedPlan = '') => {
  const dispatch = useDispatch();

  const { isFetching, isFetchingStatus, isStatusSuccess } = useSubscription();
  const isAuthenticated = useSelector((s) => s.user.isAuthenticated);
  const plans = useSelector((s) => s.plans);

  useEffect(() => {
    if (!isAuthenticated || (isAuthenticated && !isFetchingStatus && !isFetching && isStatusSuccess)) {
      dispatch(getPlans(preSelectedPlan));
    }
  }, [dispatch, isAuthenticated, isFetchingStatus, isFetching, isStatusSuccess, preSelectedPlan]);

  return plans;
};
